$(document).ready(function () {
    var $container = $('.js-media');
    var masonryInit = function masonryInit() {
        $container.masonry({
            itemSelector: '.b-media__item',
            columnWidth: '.js-grid-sizer',
            percentPosition: true
        });
    };
    $container.imagesLoaded(function () {
        masonryInit();
    });
    $(document).on('click', '.js-all', function () {
        $('.b-media__item').show();
        masonryInit();
    });
    $(document).on('click', '.js-video', function () {
        $('.js-media-video').show();
        $('.js-media-image').hide();
        $container.masonry('destroy');
    });
    $(document).on('click', '.js-image', function () {
        $('.js-media-item').hide();
        $('.js-media-image').each(function() {
            if (!$(this).attr('data-download')) {
                $(this).show();
            }
        });
        masonryInit();
    });
    $(document).on('click', '.js-download', function() {
        $('.js-media-item').hide();
        $('.js-media-item').each(function() {
            var dataDownload = $(this).attr('data-download');
            if (typeof dataDownload !== typeof undefined && dataDownload !== false) {
                $(this).show();
            }
        });
        $container.masonry({
            itemSelector: '.js-media-item',
            columnWidth: '.js-grid-sizer-download',
            percentPosition: true
        });
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/media/media.js